import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import SellOrDispose from '../modals/SellOrDispose';
import EventEmitter from '../utils/eventEmitter';
import PauseDepreciation from '../modals/PauseDepreciation';
import ModifyDepreciation from '../modals/ModifyDepreciation';
import useAssetAPI from '../apis/assetAPI';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import getDepreciationDates from '../utils/getDepreciationDate';
import calculateProrataDepreciation from '../utils/calculateProrataDepreciation';
import { GrMenu } from "react-icons/gr";



const columns = [
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Depreciation',
    dataIndex: 'depreciation',
    key: 'depreciation',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Accummulated Depreciation',
    dataIndex: 'accummulated_depreciation',
    key: 'accummulated_depreciation',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Book Value',
    dataIndex: 'book_value',
    key: 'book_value',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  // {
  //   title: 'Action',
  //   key: 'operation',
  //   fixed: 'right',
  //   width: 100,
  //   className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  //   render: (_, record) => (
  //     <Link className='h-full w-full' to={'/assets'}>
  //       EDIT
  //     </Link>
  //   )
  // }
]

const periods = [{value: 'years', label: 'Year(s)'}, {value: 'months', label: 'Month(s)'}];


const AssetChanges = () => {
  const { fixed_asset_accounts, depreciation_accounts, journals, asset } = useLoaderData();
  asset['acquisition_date'] = asset.acquisition_date ? dayjs(asset['acquisition_date'], 'YYYY-MM-DD') : '';
  asset['start_depreciating_date'] = asset.start_depreciating_date ? dayjs(asset['start_depreciating_date'], 'YYYY-MM-DD') : '';
  const [formValue, setFormValue] = useState(asset.seo ? {status: asset.status, name: asset.name} : {status: 'discard'});
  const [value, setValue] = useState();
  const [prorata, setProrata] = useState(false);
  const [form] = Form.useForm();
  const onChangeName = (e) => setFormValue({...formValue, name: e.target.value});
  const [depreciationBoard, setDepreciationBoard] = useState([]);
  const navigate = useNavigate();
  const { saveAsset, updateAssetStatus, update } = useAssetAPI();
  const { success, error } = useOutletContext();
  const params = useParams();


  const onChange = (e) => {
    setValue(e.target.value)
  };

  const toggleProrata = () => setProrata(!prorata);
  

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = formValue.name;
    data['seo'] = formValue.name.replace(/ /g, '-').toLowerCase();
    data['acquisition_date'] = new Date(dayjs(data.acquisition_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['start_depreciating'] = new Date(dayjs(data.start_depreciating, 'YYYY-MM-DD').toDate()).toLocaleDateString();
    data['depreciation_board'] = depreciationBoard;
    saveAsset(data, success);
  };

  const handleUpdate = () => { 
    let data = form.getFieldsValue();
    data['name'] = formValue.name;
    data['seo'] = formValue.name.replace(/ /g, '-').toLowerCase();
    data['acquisition_date'] = new Date(dayjs(data.acquisition_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['start_depreciating_date'] = new Date(dayjs(data.start_depreciating_date, 'YYYY-MM-DD').toDate()).toLocaleDateString();
    if (depreciationBoard.length > 0) data['depreciation_board'] = depreciationBoard;
    update(data.seo, data, success);
    // console.log(data['prorata_temporis'])
  };

  const handleAction = () => { 
    const action = formValue.status;
    if (action === 'discard') {
      handleSave();
    }else if (action === 'update') {
      handleUpdate();
    }
  }
 
  const handleDiscard = () => setFormValue({...formValue, status: 'update'});

  const preProcessformData = () => {
    let formData = form.getFieldsValue();
    const duration = formData.duration.number*1;
    const original_value = formData.original_value;
    const non_depreciable_value = formData.non_depreciable_value
    const depreciable = parseFloat(original_value - non_depreciable_value).toFixed(2);
    return {duration, original_value, non_depreciable_value, depreciable};
  }

  const calculateDatesInPeriod = (period, duration, date) => {
    switch (period) {
      case 'years':
        return getDepreciationDates(date, duration, true);
      case 'months':
        return getDepreciationDates(date, duration, false);
    }
  }

  const computeStraightLineDepreciation = () => {
    let formData = form.getFieldsValue();
    let {duration, original_value, non_depreciable_value, depreciable } = preProcessformData();
    
    let dates = [];
    const date = dayjs(formData.start_depreciating_date, 'YYYY-MM-DD').toJSON();
    const acquisition_date = dayjs(formData.acquisition_date, 'YYYY-MM-DD').toJSON();

    dates = calculateDatesInPeriod(formData.duration.period, duration, date);
    let depreciation_charge = parseFloat(depreciable / duration).toFixed(2)*1;
    let prorataTemporisDepreciation = calculateProrataDepreciation(acquisition_date, date, depreciation_charge);  

    let depreciation_board_ = [];
    if (prorata) {
      depreciation_board_.push({
        reference: `${formValue.name} (prorata entry)`,
        date: new Date(acquisition_date).toLocaleDateString(), 
        depreciation: prorataTemporisDepreciation, 
        accummulated_depreciation: prorataTemporisDepreciation,
        book_value: depreciable - prorataTemporisDepreciation
      });
      for(var i = 0; i <= duration-1; i++ ) {
        const accummulated_depreciation = (depreciation_board_[i]['accummulated_depreciation'] + depreciation_charge).toFixed(2)*1; 
        const book_value = parseFloat((depreciable - accummulated_depreciation).toFixed(2)*1);
        let chargeObj = {reference: `${formValue.name} (${i+1}/${duration})`, date: dates[i], depreciation: depreciation_charge, accummulated_depreciation: accummulated_depreciation, original_value, book_value: book_value };
        depreciation_board_.push(chargeObj);
      };
      const lastTwoData = depreciation_board_.slice(-2);
      depreciation_board_[depreciation_board_.length - 1]['depreciation'] = lastTwoData[0]['book_value'];
      depreciation_board_[depreciation_board_.length - 1]['accummulated_depreciation'] = depreciable;
      depreciation_board_[depreciation_board_.length - 1]['book_value'] = non_depreciable_value;
    }else {
      for(var i = 1; i <= duration; i++ ) {
        const accummulated_depreciation = (depreciation_charge * i).toFixed(2)*1
        const book_value = (depreciable - accummulated_depreciation).toFixed(2)*1;
        let chargeObj = {reference: `${formValue.name} (${i}/${duration})`, date: dates[i-1], depreciation: depreciation_charge, accummulated_depreciation: accummulated_depreciation, original_value, book_value: book_value };
        depreciation_board_.push(chargeObj);
      };
    }
    // NORMALIZE END OF DEPRECIATION
    // const lastTwoData = depreciation_board_.slice(-2);
    // depreciation_board_[depreciation_board_.length - 1]['depreciation'] = lastTwoData[0]['book_value'];
    // depreciation_board_[depreciation_board_.length - 1]['accummulated_depreciation'] = depreciable;
    // depreciation_board_[depreciation_board_.length - 1]['book_value'] = non_depreciable_value;
    // END OF DEPRECIATION

    setDepreciationBoard(depreciation_board_);
    form.setFieldValue('depreciable_value', depreciable);
    form.setFieldValue('book_value', non_depreciable_value);
    setFormValue({...formValue, book_value: non_depreciable_value })
    return {depreciation_board_, depreciable, non_depreciable_value};
  }

  const computeReducingBalanceDepreciation = () => {
    let depreciation_board_ = [];
    let {duration, non_depreciable_value, depreciable } = preProcessformData();
    let cummulative = 0;
    let depreciationCharge = 0;
    let book_value = depreciable;
    let formData = form.getFieldsValue();
    const date = dayjs(formData.start_depreciating_date, 'YYYY-MM-DD').toJSON();
    const acquisition_date = dayjs(formData.acquisition_date, 'YYYY-MM-DD').toJSON();
    
    const dates = calculateDatesInPeriod(formData.duration.period, duration, date);
    let depreciationCharge_ = parseFloat((depreciable * formData.factor*1).toFixed(2)); // this is also the depreciation expense throught out the lifespan of the asset
    depreciationCharge_ /= 12;
    let prorataTemporisDepreciation = calculateProrataDepreciation(acquisition_date, date, depreciationCharge_); 
    
    if (prorata) {
      
      depreciation_board_.push({
        reference: `${formValue.name} (prorata entry)`,
        date: new Date(acquisition_date).toLocaleDateString(), 
        depreciation: prorataTemporisDepreciation, 
        accummulated_depreciation: prorataTemporisDepreciation,
        book_value: book_value - prorataTemporisDepreciation
      });
      let depreciationCharge = depreciation_board_[0]['depreciation'];
      let book_value_ = depreciation_board_[0]['book_value'];
      let cummulative = depreciation_board_[0]['accummulated_depreciation'];
      if (formData.duration.period === 'years'){
        for(var i = 0; i <= duration-1; i++ ) { 
          depreciationCharge = parseFloat((book_value_ * formData.factor*1).toFixed(2)); // this is also the depreciation expense throught out the lifespan of the asset
          book_value_ -= depreciationCharge; 
          cummulative += depreciationCharge;
          let chargeObj = {reference: `${formValue.name} (${i+1}/${duration})`, date: dates[i], depreciation: depreciationCharge, accummulated_depreciation: parseFloat(cummulative).toFixed(2), book_value: parseFloat(book_value_).toFixed(2) };
          depreciation_board_.push(chargeObj);
        }
      }else if (formData.duration.period === 'months'){
        for(var i = 0; i <= duration-1; i++ ) {
          
          depreciationCharge = parseFloat(((book_value_ * formData.factor*1) / 12).toFixed(2)); 
          book_value_ -= depreciationCharge; 
          cummulative += depreciationCharge;

          let chargeObj = {reference: `${formValue.name} (${i+1}/${duration})`, date: dates[i], depreciation: depreciationCharge, accummulated_depreciation: parseFloat(cummulative).toFixed(2), book_value: parseFloat(book_value_).toFixed(2) };
          depreciation_board_.push(chargeObj);
        }
      }
      const firstTwoData = depreciation_board_.slice(0, 2);
      console.log(firstTwoData)
      // depreciation_board_[depreciation_board_.length - 1]['depreciation'] = firstTwoData[0]['book_value'];
      // depreciation_board_[depreciation_board_.length - 1]['accummulated_depreciation'] = depreciable;
      // depreciation_board_[depreciation_board_.length - 1]['book_value'] = non_depreciable_value;
    }else {
      if (formData.duration.period === 'years'){
        for(var i = 1; i <= duration; i++ ) { 
          depreciationCharge = parseFloat((book_value * formData.factor*1).toFixed(2)); // this is also the depreciation expense throught out the lifespan of the asset
          book_value -= depreciationCharge; 
          cummulative += depreciationCharge;
          let chargeObj = {reference: `${formValue.name} (${i}/${duration})`, date: dates[i-1], depreciation: depreciationCharge, accummulated_depreciation: parseFloat(cummulative).toFixed(2), book_value: parseFloat(book_value).toFixed(2) };
          depreciation_board_.push(chargeObj);
        }
      }else if (formData.duration.period === 'months'){
        for(var i = 1; i <= duration; i++ ) { 
          depreciationCharge = parseFloat(((book_value * formData.factor*1) / 12).toFixed(2)); 
          book_value -= depreciationCharge; 
          cummulative += depreciationCharge;
          let chargeObj = {reference: `${formValue.name} (${i}/${duration})`, date: dates[i-1], depreciation: depreciationCharge, accummulated_depreciation: parseFloat(cummulative).toFixed(2), book_value: parseFloat(book_value).toFixed(2) };
          depreciation_board_.push(chargeObj);
        }
      }
      // for(var i = 1; i <= duration; i++ ) { 
      //   let chargeObj = declineDepreciationCalculation(i, depreciationCharge, book_value, cummulative, duration, dates, formData);
      //   // depreciationCharge = parseFloat((book_value * formData.factor*1).toFixed(2)); // this is also the depreciation expense throught out the lifespan of the asset
      //   // book_value -= depreciationCharge; 
      //   // cummulative += depreciationCharge;
      //   // let chargeObj = {reference: `${formValue.name} (${i}/${duration})`, date: dates[i-1], depreciation: depreciationCharge, accummulated_depreciation: parseFloat(cummulative).toFixed(2), book_value: parseFloat(book_value).toFixed(2) };
      //   depreciation_board_.push(chargeObj);
      // }
    }
    
    // NORMALIZE END OF DEPRECIATION
    // const lastTwoData = depreciation_board_.slice(-2);
    // depreciation_board_[depreciation_board_.length - 1]['depreciation'] = lastTwoData[0]['book_value'];
    // depreciation_board_[depreciation_board_.length - 1]['accummulated_depreciation'] = depreciable;
    // depreciation_board_[depreciation_board_.length - 1]['book_value'] = non_depreciable_value;
    // END OF DEPRECIATION
    
    setDepreciationBoard(depreciation_board_);
    form.setFieldValue('depreciable_value', depreciable);
    form.setFieldValue('book_value', non_depreciable_value);
    setFormValue({...formValue, book_value: non_depreciable_value })
    return {depreciation_board_, depreciable, non_depreciable_value};

  }

  const computeDepreciation = () => {
    const method = form.getFieldValue('method');
    if (method === 'straight_line') {
      computeStraightLineDepreciation();
    }else if (method === 'declining') {
      computeReducingBalanceDepreciation();
    }
  }


  useEffect(() => {
    EventEmitter.subscribe('saveAssetResponse', data => {
      navigate('/accounting/assets/'+data.seo);
      setFormValue({...formValue, status: data.status});
    });
    EventEmitter.subscribe('sell_asset', data => {
      setFormValue({...formValue, status: data});
    });

    EventEmitter.subscribe('updateStatusAssetResponse', data => {
      setFormValue({...formValue, status: data.status});
    });

    return () => {
      EventEmitter.unsubscribe('saveAssetResponse');
      EventEmitter.unsubscribe('sell_asset');
      EventEmitter.unsubscribe('updateStatusAssetResponse');
    }
  },[])
  
  // console.log(formValue )
  const handleConfirm = () => {
    updateAssetStatus(asset.seo, 'running', success);
    // setFormValue({...formValue, status: 'running'});
  }
  const sellOrDispose = () => EventEmitter.dispatch('openSellOrDisposeModal', true);
  const pauseDepreciation = () => EventEmitter.dispatch('pause_depreciation', true);
  const resumeModifyDepreciation = () => EventEmitter.dispatch('resume_modify_depreciaion', true);
  
  // console.log(form.getFieldValue('prorata_temporis').isProrataTemporis);
  return (
    <div className='container mx-auto h-full pb-4' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link to={'/accounting/assets'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Assets</Link> / {params.action}
          </h3>
          <Tooltip  title={formValue.status === 'update' ? 'update' : 'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleAction} type='text' htmlType='button'
              disabled={ (formValue.status === 'discard' || formValue.status === 'update') ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              disabled={ (formValue.status === 'draft') ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip>
        </div>
      </div>
      {/* <div>
        <Button onClick={()=>handleSave('posted')} htmlType='button' className='me-1'>SAVE</Button> 
        <Button onClick={handleDiscard} htmlType='button' >DISCARD</Button>
      </div> */}
      <div className='flex justify-between align-center border-y-2' style={{paddingTop: '1px', paddingBottom: '1px'}}>
        {formValue.status === 'done' && <p className='m-0'>Asset Done</p>}
        {(formValue.status !== 'running') && <div>
          <Button onClick={()=>handleConfirm('posted')} htmlType='button' className='me-1'>CONFIRM</Button> 
          <Button onClick={computeDepreciation} htmlType='button' >COMPUTE DEPRECIATION</Button>
        </div>}
        {formValue.status === 'running' && <div>
          <Button onClick={sellOrDispose} htmlType='button' >SELL OR DISPOSE</Button> 
          <Button onClick={pauseDepreciation} htmlType='button' className='mx-1'>PAUSE DEPRECIATION</Button>
          <Button onClick={resumeModifyDepreciation} htmlType='button' >MODIFY DEPRECIATION</Button>
        </div>}
        {(formValue.status === 'draft' || formValue.status === 'running' || formValue.status === 'done') && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  formValue.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li 
                className = { 
                  // formValue.status === 'running' ? 'posted posted-status' : 'posted-status posted-transparent'
                  formValue.status === 'running' ? 'middle middle-status' : 'middle-status middle-transparent'
                }
              >
                RUNNING
              </li>
              <li
                className={
                  formValue.status === 'done'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                DONE
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-5 bg-white shadow '>
        <div className='flex justify-end border-b-2'>
          <Link className='flex right-0 pe-2'>
            <GrMenu size={'2rem'} color='text-slate-500'/>
            <div className='flex flex-col'>
              <span className='' style={{marginTop: '-2px'}}>{0}</span>
              <span style={{marginTop: '-10px'}} color='text-gray-500'>Posted Entries</span>
            </div>
          </Link>
        </div>
        <div className='p-3'>
          <FloatingLabel 
            name='name'
            className='text-2xl' 
            variant="standard"
            disabled={(formValue.status!== 'discard' && formValue.status !== 'update') ? true : false}
            label="Asset Name"
            value={formValue.name} 
            onChange={onChangeName}
          />
          <Tabs
            className='mt-3'
            // onChange={onChange}
            type='card'
            items={[
              {
                key: '1',
                label: 'Asset',
                children: 
                <Form name="basic"
                  form={form}
                  labelAlign='left'
                  labelCol={{span: 10}}
                  initialValues={asset.seo ? asset : {  
                    duration: {number: 1, period: 'years'},
                    prorata_temporis: false,
                    method: 'straight_line',
                    non_depreciable_value: 0.00,
                    depreciable_value: 0.00,
                    book_value: 0.00
                  }}
                  disabled={(formValue.status!== 'discard' && formValue.status !== 'update') ? true : false}
                  autoComplete="off"
                  variant='borderless'
                >
                  {/* <Form.Item label='Asset Name' name="name" labelAlign='' className='font-bold mb-2 column' required >
                    <Input className='border-x-0 border-t-0 input-outline-none font-normal' placeholder='eg. Computer' value={formValue.name} onChange={onChangeName}/>
                  </Form.Item> */}
                  

                  <Row className='mt-5'>
                    <Col lg={{span: 11}}>
                      <Badge className="text-slate-500 text-xl bg-transparent	">Asset Values</Badge>
                      <Form.Item label='Original Value' name="original_value" className='font-semibold text-gray-800 mb-2 column' required >
                        <InputNumber className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
                      </Form.Item>
                      <Form.Item label='Acquisition Date' name="acquisition_date" className='font-semibold mb-2 column' required >
                        <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal'/>
                        {/* <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' checked={formValue.active} value={formValue.active} onChange={onChangeActive}/> */}
                      </Form.Item>
                    </Col>
                    <Col lg={{span: 11, offset: 1}}>
                      <Badge className="text-slate-500 text-xl bg-transparent	">Current Values</Badge>
                      <Form.Item label="Non Depreciable Value" name="non_depreciable_value" className='font-semibold mb-2' required >
                        <InputNumber className='border-2 border-b-2 w-full font-normal' />
                      </Form.Item>
                      <Form.Item label='Depreciable Value' name={'depreciable_value'} className='font-semibold columns mb-2' required >
                        <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal' disabled={true}/>
                      </Form.Item>
                      <Form.Item label='Book Value' name={'book_value'} className='font-semibold columns mb-2' required >
                        <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal' disabled={true}/>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className='mt-5'>
                    <Col lg={{span: 11}}>
                      <Badge className="text-slate-500 text-xl bg-transparent	">Depreciation Method</Badge>
                      <Form.Item label='Method' name="method" className='font-semibold text-gray-800 mb-2 column' required >
                        <Radio.Group onChange={onChange} value={value}>
                          <Radio value={'straight_line'} className='font-normal'>Straight Line</Radio>
                          <Radio value={'declining'} className='font-normal'>Declining</Radio>
                        </Radio.Group> 
                      </Form.Item>
                      {form.getFieldValue('method')==='declining' && 
                        <Form.Item label='Factor' name={'factor'} className='font-semibold column mb-2' required >
                          <InputNumber min={0} max={1} className='border-x-0 border-t-0 input-outline-none font-normal w-full '/>
                        </Form.Item>
                      }
                      <Form.Item label='Duration' className='font-semibold column mb-2' required >
                        <Space.Compact>
                          <Form.Item name={['duration', 'number']} noStyle>
                            <InputNumber className='input-outline-none font-normal' name='number' />
                          </Form.Item>
                          <Form.Item name={['duration', 'period']} noStyle>
                            <Select options={periods} className='border-b-2' name='period' style={{width: 100}}/>
                          </Form.Item>
                        </Space.Compact>
                      </Form.Item>  
                      <Form.Item label='Prorata Temporis' name={'prorata_temporis'} valuePropName='checked' className='font-semibold mb-2 column' required >
                        <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' onClick={toggleProrata} />
                      </Form.Item>
                      <Form.Item label={'Start Depreciating'} name="start_depreciating_date" className='font-semibold mb-2' required>
                        <DatePicker className='border-x-0 border-t-0 input-outline-none border-0 font-normal w-full' />
                      </Form.Item>
                    </Col>
                    <Col lg={{span: 11, offset: 1}}>
                      <Badge className="text-slate-500 text-xl bg-transparent	">Accounting</Badge>
                      <Form.Item label="Fixed Asset Account" name="fixed_asset_account" className='font-semibold columns mb-2' required >
                        <Select options={fixed_asset_accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='input-outline-none'/>
                      </Form.Item>
                      <Form.Item label='Depreciation Account' name={'depreciation_account'} className='font-semibold columns mb-2' required >
                      <Select options={fixed_asset_accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='input-outline-none'/>
                      </Form.Item>
                      <Form.Item label='Expense Account' name={'expense_account'} className='font-semibold columns mb-2' required >
                        <Select options={depreciation_accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='input-outline-none' />
                      </Form.Item>
                      <Form.Item label='Journal' name={'journal_id'} className='font-semibold columns mb-2' required >
                        <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))} className='input-outline-none' />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              },
              depreciationBoard.length > 0 && 
              {
                key: '2',
                label: 'Depreciation Board',
                active: depreciationBoard.length > 0 ? true : false,
                children: 
                <Table
                  sticky
                  dataSource={depreciationBoard}
                  columns={columns}
                  scroll={{ y: 400,}}
                  pagination={false}
                />
              }
            ]}
          />
        </div>
      </div>
      <SellOrDispose />
      <PauseDepreciation />
      <ModifyDepreciation />
    </div>
  )
}

export default AssetChanges;